export enum SocketCommand {
  RESET = 'RESET',
}

export enum ConnectType {
  WEB_MACHINE = 'WEB_MACHINE',
  DESKTOP_MACHINE = 'DESKTOP_MACHINE',
}
